
import React from "react";
import { useProgramCreation } from "@/contexts/ProgramCreationContext";

export default function ProgramCreationHeader() {
  const { step } = useProgramCreation();

  return (
    <div className="flex items-center justify-between animate-fade-in">
      <div>
        <h1 className="text-3xl font-bold tracking-tight text-white">Create Program</h1>
        <p className="text-white/70">
          {step === 1 && "Select a client and review their information"}
          {step === 2 && "Add program details and health information"}
          {step === 3 && "Complete tier-specific questions"}
          {step === 4 && "Set your preferences and customizations for the program"}
          {step === 5 && "Review all information before finalizing the program"}
        </p>
      </div>
    </div>
  );
}
